export default function rlxContactLocationChooser() {
    const $form = $('#rlx-v7-contact__form');

    if ($form.length === 0) {
        return;
    }

    const $locationSelect = $form.find('.js-location-select');
    const $storeSelect = $form.find('.js-store-select');
    const $inputLocationName = $form.find('input[name="city"]');
    const $inputStoreName = $form.find('input[name="storeName"]');
    const isRolexCpo = $form.find('input[name="isRolexCpo"]').val() === '1';

    /**
     *
     */
    const updateInputStoreNameValue = () => {
        const $locationOptionSelected = $form.find('.js-location-select option:selected');
        const $storeOptionSelected = $form.find('.js-store-select option:selected');

        if ($locationOptionSelected.length > 0 && $locationOptionSelected.val() !== '') {
            $inputLocationName.attr('value', $locationOptionSelected.text());
        }

        if (isRolexCpo && $storeOptionSelected.length > 0) {
            $inputLocationName.attr('value', $storeOptionSelected.data('city') || '');
        }

        if ($inputStoreName.length > 0) {
            $inputStoreName.attr('value', $storeOptionSelected.text());
        }
    };

    /**
     *
     * @param city
     */
    const updateStores = (city) => {
        const locale = window.location.pathname.split('/')[1];
        const isRolexCpoQuery = isRolexCpo ? '&isRolexCpo=true' : '';

        $.get(`/${locale}/RolexContactStore?city=${city}${isRolexCpoQuery}`, [], (response) => {
            if (response.stores.length > 0) {
                response.stores.forEach((store, index) => {
                    const $option = $(`<option value="${store.id}">${store.name}</option>`);

                    if (index === 0) {
                        $option.attr('selected', 'selected');
                    }

                    if ($storeSelect.find(`option[value="${store.id}"]`).length === 0) {
                        $storeSelect.append($option);
                    }
                });
            }
        })
            .done(() => {
                updateInputStoreNameValue();
            });
    };

    /**
     *
     */
    const removeStores = () => {
        $storeSelect.find('option').each((index, $store) => {
            if (index !== 0) {
                $store.remove();
            }
        });
    };

    /**
     *
     */
    const disableStoreDropdown = () => {
        $storeSelect.attr('disabled', 'disabled');
    };

    /**
     *
     */
    const enableStoreDropdown = () => {
        $storeSelect.removeAttr('disabled');
    };

    if (!isRolexCpo) {
        $locationSelect.on('change', (event) => {
            const $this = $(event.currentTarget);

            removeStores();

            if ($this.val() === '') {
                disableStoreDropdown();
            } else {
                updateStores($this.val());
                enableStoreDropdown();
            }
        });
    } else {
        enableStoreDropdown();
        updateInputStoreNameValue();
    }

    $storeSelect.on('change', () => {
        updateInputStoreNameValue();
    });
}
